import { useAuth } from '@clerk/clerk-react';

import { trpc } from '@/lib/api/trpc';

export type ProcessingApplicationState = 'none' | 'draft' | 'in_review' | 'approved' | 'live' | 'rejected';

/**
 * Has this account already applied for TagadaPay processing, and how far did it
 * get? Read by the activation gate so an approved merchant is never asked to
 * "Apply for TagadaPay" a second time — the single most common support ticket
 * out of that screen ("it keeps redirecting me, I already submitted").
 *
 * Errors read as `none`: the gate must degrade to its plain two-path screen
 * rather than hiding the one action (adding a card) that unblocks the account.
 */
export function useProcessingApplication() {
  const { isLoaded, isSignedIn } = useAuth();

  const { data, isLoading } = trpc.activation.processingApplication.useQuery(undefined, {
    enabled: isLoaded && isSignedIn,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  return {
    application: data ?? null,
    state: (data?.state ?? 'none') as ProcessingApplicationState,
    isLoading: !isLoaded || !isSignedIn || isLoading,
  };
}
